import { Breakpoints } from '@apps/gated-2021/breakpoints';
import { Colors } from '@src/colors';
import styled from 'styled-components';
import * as styledText from '../components/form.styled';

export const ThankYou = styled.div`
    align-self: center;
    & + .div {
        display: block !important;
    }

    @media print {
        background-color: ${Colors.white};
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 936px;
`;

export const Title = styled(styledText.Title)`
    @media screen and (max-width: ${Breakpoints.mobile}) {
        font-size: 38px;
        letter-spacing: -0.2px;
        line-height: 40px;
        text-align: start;
    }
`;

export const Subtitle = styled(styledText.Subtitle)`
    line-height: 27.5px;
    font-size: 20px;
    max-width: 474px;
    margin-bottom: 0;

    a {
        color: ${Colors.white};

        :hover {
            text-decoration: none;
        }
    }

    br {
        margin-bottom: 30px;
    }

    p {
        margin-bottom: 0;
    }

    svg {
        height: 17px;
        width: 21px;

        @media screen and (max-width: ${Breakpoints.mobile}) {
            height: 13px;
            width: 17px;
        }
    }

    @media screen and (max-width: ${Breakpoints.mobile}) {
        font-size: 16px;
        line-height: 23px;
        text-align: start;
    }
`;
